import { get, post, put, formGet, formPost } from "./Http"


/**
 * 查询部门
 * @param post
 * @param list: {"isContentEmpty": true,"notNeedPage": true,isInactive:false}
 * @returns {*}
 */
function departmentQuery(list) {
  return post('/ctx-setting/v1/department/query', list)
}

//检测帐户是否存在
function isExist(user) {
  return post('/ctx-user/v1/user/isExist', { 'account': user })
}

//检测帐户是否不存在
function isNotExist(user) {
  return post('/ctx-user/v1/user/isNotExist', { 'account': user })
}

// 用户注册
function create(data) {
  return post('/ctx-user/v1/user/create', data)
}

// 我的易嘉设置
function updateEntrance(code) {
  return put('/ctx-user/v1/user/updateEntrance', { 'entrance': code })
}

// 用户找回密码提交新密码信息
function resetPassword(confirm, account, password, passwordStrength) {

  return post('/ctx-user/v1/user/resetPassword', {
    "confirmCode": confirm,
    "account": account,
    "password": password,
    'passwordStrength': passwordStrength
  })
}

// 用户登录
function getLoginToken(query) {
  return post('/api-oauth/oauth/token', query);
}
// 获取用户信息
function getUserInfo(query) {
  return get('/api-sys/sysuser/users/current', query);
}

function getRolesList(params) {
  return get(`/api-sys/sysrole/findRoleList?orgId=${params.orgId}&identity=${params.system}`)
}

//用户登录
function logon(query) {
  return post('/api-oauth/oauth/token', query);
}

function exchangeToken(type) {
  return post(`/ctx-portal/v1/indexData?type=${type}`);
}

// 退出登录
function logout() {
  return post('/ctx-portal/v1/portal/logout', {})
}

//检验手机或邮箱是否已经被绑定
function isExistBind(user) {
  return post('/ctx-user/v1/user/isExistBind', { 'account': user })
}

//绑定手机或邮箱
function bindAccount(user) {
  return post('/ctx-user/v1/user/bindAccount', { 'account': user })
}

//修改手机或邮箱
function updateBindAcount(user, pwd) {
  return post('/ctx-user/v1/user/updateBindAcount', { 'account': user, 'password': pwd })
}

//修改绑定前校验密码
function validatePassword(pwd) {
  return post('/ctx-user/v1/user/validatePassword', { 'password': pwd })
}

//获取用户信息
function getById() {
  return post('/ctx-user/v1/user/getById')
}

//创建企业用户
function companyCreate(list) {
  return post('/ctx-user/v1/user/companyCreate', list)
}

// // ORC识别企业信息
// function companyCreate(list) {
//   return post('/ctx-user/v1/files/uploadAndRecognition', list)
// }

//更新个人基础信息
function update(name) {
  return post('/ctx-user/v1/user/update', { 'name': name })
}

//获取用户所有基本信息
function init(orgId = -1) {
  return post('/ctx-setting/v1/web/portal/init', {orgId});
}

function loadPerson(id) {
  return post('/ctx-user/v1/sysuser/getById', { id: id })
}

function updatePerson(id) {
  return post('/ctx-user/v1/sysuser/updateSelf', id)
}

function upDown(id) {
  return formGet('/ctx-user/v1/files/download', id)
}
//验证是否存在金税师服务
function checkService(query) {
  return post('/ctx-portal/v1/orgserv/checkService', query)
}

//管理端验证按钮跳转金税师验证是否允许跳转
function portalToJss(query) {
  return post(`/ctx-portal/v1/portal/portalToJss?flag=${query.flag}`)
}

//服务之间跳转都改为本接口
function linkToPOST(query) {
  return post(`/ctx-portal/v1/linkTo?flag=${query.flag}&type=${query.type}&orgId=${query.orgId}`)
}

// 进入演示账套接口
// function temporarySystemOrg() {
//   return post('/ctx-portal/v1/portal/temporarySystemOrg/init')
// }

// 进入演示账套接口
function temporarySystemOrg(token) {
  return get('/ctx-portal/v1/portal/temporarySystemOrg/intoDemo?token=' + token)
}

//金税师获取信息接口
function goJss() {
  return post('/ctx-user/v1/goJss', {})
}

//base64上传接口
function uploadBase(data) {
  return post('/ctx-user/v1/files/uploadBase64', data)
}



//获取用户菜单列表
function getMenus(query) {
  return post('/ctx-portal/v1/rolefunc/findUserRoleFunctionList', query)
}

// 获取uuid
function getUUID() {
  return get('/ctx-portal/v1/verification/getUUID?project=base');
}

// 根据uuid获取图片验证码
function getVerification(uuid) {
  return post('/ctx-portal/v1/verification/getVerification', uuid);
}

// 校验图片验证码
function checkVerification(query) {
  return post('/ctx-portal/v1/verification/check', query);
}

//修改密码
function changePwd(query) {
  return post('/ctx-portal/v1/operate/changePassword', query)
}

//验证图片验证码
function verifyCode(query) {
  return post('/ctx-portal/v1/checkVerifyCode', query)
}


//获取手机验证码
function getMobileCode(query) {
  return post('/ctx-portal/v1/operate/sendForgetPwd', query)
}

// 验证手机验证码
function identifyingCode(query) {
  return post('/ctx-portal/v1/operate/checkForgetPwd', query)
}

// 个人中心发送手机验证码
function sendMessageCode(params) {
  return post('/ctx-portal/v1/operate/user/sendMessageCode', params);
}

// 个人中心发送手机验证码
function newSendMessageCode(params) {
  return post('/ctx-portal/v1/operate/user/sendMessageCode1', params);
}
// 个人中心验证手机验证码
function newCheckMessageCode(params) {
  return post('/ctx-portal/v1/operate/user/checkMessageCode1', params);
}

// 个人中心验证手机验证码
function checkMessageCode(params) {
  return post('/ctx-portal/v1/operate/user/checkMessageCode', params);
}


//找回密码
function findPwd(query) {
  return post('/ctx-portal/v1/operate/changePwd', query)
}

//验证手机号是否已注册
function checkIsRegist(query) {
  return post('/ctx-portal/v1/JssRegist/checkIsRegist', query)
}

//验证手机号是否已注册
function signUp(query) {
  return post('/ctx-portal/v1/JssRegist/register', query)
}

//启用库存管理
function inventoryEnabled(query) {
  return post('/ctx-user/v1/sysOrg/enableStockManage', query)
}

function getImgUrl(query) {
  return post('/ctx-user/v1/files/getImgUrl', query)
}

function findFilesByIds(query) {
  return post('/ctx-user/v1/files//findFilesByIds', query)
}

//获取快捷键
function getHotKey(query) {
  return post('/ctx-portal/v1/shortcutsKey/queryByUserId', query)
}

//新增、更新快捷键
function updateHotKey(query) {
  return post('/ctx-portal/v1/shortcutsKey/save', query)
}


//新增、更新快捷键
function deleteHotKey(query) {
  return post('/ctx-portal/v1/shortcutsKey/delete', query)
}


//根据账套id获取账套信息
function getOrgInfo(query) {
  return post('/ctx-user/v1/sysOrg/getById', query)
}

//获取公司的所有办事人员
function getCorpUser(query) {
  return post('/ctx-portal/v1/corpUser/queryByCorpId', query)
}


//获取聊天消息
function getChatMessage(query) {
  return post('/ctx-portal/v1/chtRcd/query', query)
}

//新建聊天消息
function createChatMessage(query) {
  return post('/ctx-portal/v1/chtRcd/create', query)
}

//获取该公司计费项目
function getBusinessProduct(query) {
  return post('/ctx-finance/v1/portalContract/query', query)
}


//保存该公司计费
function saveBusinessProduct(query) {
  return post('/ctx-finance/v1/portalContract/updateShare', query)
}

//获取账套默认会计期
function getDefaultPeriod(query) {
  return post('/ctx-finance/v1/ctxHome/queryDefaultPeriod', query)
}

//获取当前运行版本
function getRte() {
  return get('/ctx-portal/v1/redis/getRte')
}
//同步资产管理平台个性化设置
function asyncAssignment(params) {
  return post("/ctx-asset/v1/assetConfig/syncAssignmentTime", params)
}
//获取人员列表
function queryPersonalList(param) {
  return post("/ctx-setting/v1/personnel/query", param);
}

// 资源管理私有化账套基础数据
function orgInitRules(query) {
  return post("/ctx-resources/v1/resourcesBasicData/orgInitRules", query);
}

// 首页查询 档案首页查询大类统计 "bigClassId" 完税情况2002  社保2003 合同数量2001
function countByBigClass(query) {
  return post("/ctx-qy-archive/v2/archive/countByBigClassBatch", query);
}
// 首页查询 票据管理 会计凭证数量
function queryJournalCount(query) {
  return post("/ctx-finance/v1/journal/queryJournalCount", query);
}
// 首页查询 会计凭证数量
function queryCollectionVouchersNum(query) {
  return post("/ctx-qy-archive/collectionvouchers/queryCollectionVouchersNum", query);
}
// 首页获取费用类型数据
function statisticsTotalByPeriod(query) {
  return post("/ctx-finance/v1/financeTravelExpensesFee/statisticsTotalByPeriod", query);
}

// xml下载
function xmlexport(query){
  return formPost('/ctx-qy-archive/v2/archiveFile/xbrl/export',query)
}
function exportPreview(query){
  return get('/ctx-qy-archive/v2/archiveFile/xbrl/exportPreview',query)
}
function xmlexportReportXML(query){
  return formPost('/ctx-qy-archive/v2/archiveFile/xbrl/exportReportXML',query)
}
function exportReportXMLPreview(query){
  return get('/ctx-qy-archive/v2/archiveFile/xbrl/exportReportXMLPreview',query)
}
export default {
  exportPreview,exportReportXMLPreview,
  xmlexport,xmlexportReportXML,
  init, departmentQuery,
  isExist, logon, getLoginToken, getUserInfo, logout, isNotExist, create, resetPassword, upDown,countByBigClass,queryJournalCount,
  exchangeToken, getById, update, updatePerson, goJss, getRolesList,statisticsTotalByPeriod,queryCollectionVouchersNum,
  getMenus, getUUID, getVerification, checkVerification, changePwd, getMobileCode, identifyingCode, sendMessageCode, checkMessageCode, newCheckMessageCode,
  verifyCode, findPwd, checkIsRegist, signUp, linkToPOST, newSendMessageCode,
  temporarySystemOrg, inventoryEnabled, getHotKey, updateHotKey, deleteHotKey, getCorpUser,
  getChatMessage, createChatMessage, getBusinessProduct, saveBusinessProduct, getDefaultPeriod, getRte, asyncAssignment, queryPersonalList, orgInitRules,
}



// WEBPACK FOOTER //
// ./src/api/UserApi.js